export default __webpack_public_path__ + "static/media/Game Flow.fb13a702.png";